import { render, staticRenderFns } from "./ProductsClientPrices.vue?vue&type=template&id=3cd18194"
import script from "./ProductsClientPrices.vue?vue&type=script&lang=js"
export * from "./ProductsClientPrices.vue?vue&type=script&lang=js"
import style0 from "./ProductsClientPrices.vue?vue&type=style&index=0&id=3cd18194&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports